import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { LicenseManager } from 'ag-grid-enterprise'
import App from './App'
import { store } from './appState/store'
import { env } from './configs/env'

// Register the AG Grid Enterprise license globally before any grid (including
// Ursa's ObGrid) mounts. The key is injected at runtime via window._env_
// (see public/env.js + deployment/docker/run.sh) and sourced from 1Password by SRE.
LicenseManager.setLicenseKey(env.VITE_AGGRID_LICENSE_KEY)

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
)
